var _rect, _circle, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscriptionRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#FDF2ED"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.5,
    stroke: "#E87A46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1642 10.2054L11.9993 8.05056L12.8345 10.2054C12.9338 10.4617 13.1739 10.6361 13.4483 10.6514L15.7558 10.7798L13.9645 12.24C13.7515 12.4136 13.6598 12.6958 13.73 12.9615L14.321 15.1957L12.3787 13.9433C12.1477 13.7944 11.851 13.7944 11.62 13.9433L9.67774 15.1957L10.2687 12.9615C10.3389 12.6958 10.2472 12.4136 10.0342 12.24L8.2429 10.7798L10.5504 10.6514C10.8248 10.6361 11.0649 10.4617 11.1642 10.2054Z",
    stroke: "#E87A46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E87A46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionRounded);
export default __webpack_public_path__ + "static/media/SubscriptionRounded.11ee6da64565e3ce3cd9d6972d3c4ba7.svg";
export { ForwardRef as ReactComponent };